import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="bg-gradient-to-br from-teal-50 via-white to-orange-50 py-16">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center">
          <div className="inline-flex items-center space-x-2 bg-white px-4 py-2 rounded-full shadow-sm mb-6">
            <i className="ri-graduation-cap-line text-teal-600"></i>
            <span className="text-sm font-medium text-gray-700">学生・若年層向け</span>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            学生におすすめの<br className="md:hidden" />クレジットカード5選
          </h1>
          
          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            学生でも作りやすく、特典が充実したクレジットカードを厳選。<br className="hidden md:block" />
            初めてのカード選びに役立つ情報をわかりやすく解説します。
          </p>
          
          <div className="flex flex-wrap items-center justify-center gap-3 text-sm text-gray-500 mb-12">
            <div className="flex items-center space-x-1">
              <i className="ri-calendar-line text-teal-600"></i>
              <span>2026年最新版</span>
            </div>
            <span className="text-gray-300">•</span>
            <div className="flex items-center space-x-1">
              <i className="ri-user-smile-line text-teal-600"></i>
              <span>学生OK</span>
            </div>
            <span className="text-gray-300">•</span>
            <div className="flex items-center space-x-1">
              <i className="ri-shield-check-line text-teal-600"></i>
              <span>審査通りやすい</span>
            </div>
          </div>

          {/* 1️⃣ ファーストビュー即決ブロック */}
          <div className="bg-gradient-to-br from-teal-500 to-teal-600 rounded-2xl p-8 shadow-2xl border-2 border-teal-400">
            <div className="flex items-center justify-center gap-2 mb-4">
              <div className="bg-white/20 backdrop-blur-sm px-4 py-1 rounded-full">
                <span className="text-white text-sm font-bold">迷ったらコレ！</span>
              </div>
              <div className="bg-amber-400 px-4 py-1 rounded-full">
                <span className="text-amber-900 text-sm font-bold">No.1おすすめ</span>
              </div>
            </div>

            <h3 className="text-2xl md:text-3xl font-bold text-white mb-3">
              三井住友カード（NL）
            </h3>

            <div className="flex flex-wrap items-center justify-center gap-3 mb-6">
              <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg">
                <div className="text-white text-xs mb-1">年会費</div>
                <div className="text-white font-bold">永年無料</div>
              </div>
              <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg">
                <div className="text-white text-xs mb-1">還元率</div>
                <div className="text-white font-bold">最大7%</div>
              </div>
              <div className="bg-white/20 backdrop-blur-sm px-4 py-2 rounded-lg">
                <div className="text-white text-xs mb-1">発行</div>
                <div className="text-white font-bold">最短10秒</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 justify-center">
              <Link
                to="/mitsui"
                className="inline-flex items-center justify-center gap-2 bg-white text-teal-600 font-bold px-8 py-4 rounded-xl hover:bg-gray-50 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-file-list-3-line"></i>
                詳細ページを見る
              </Link>
              <a
                href="https://www.smbc-card.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-teal-700 text-white font-bold px-8 py-4 rounded-xl hover:bg-teal-800 transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
              >
                <i className="ri-external-link-line"></i>
                公式サイトはこちら
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
